import { BrandLogo } from "./BrandLogo";

export function Splash({
  sub = "Préparation de l’atelier…",
}: {
  title?: string;
  sub?: string;
}) {
  return (
    <div className="sg-boot" role="status" aria-live="polite">
      <div className="sg-boot__inner">
        <BrandLogo size="lg" />
        <p className="sg-boot__sub">{sub}</p>
        <div className="sg-boot__track">
          <span className="sg-boot__fill" />
        </div>
      </div>
    </div>
  );
}
